/* eslint-disable react/prop-types */
import React, { useRef } from 'react';
import { connect } from 'react-redux';
import { selectSectionAndCategory, setSkinTone } from '../../actions';
import classNames from 'classnames';

const SkinToneFilters = ({
    projectTitle,
    setEnableBuilder,
    dispatch,
    activeSection,
    showEditProjectInput,
    setShowSkinToneSelector,
    skintone,
    titleText,
    currentBuildIndex,
    skinToneError,
    activeFilters,
}) => {
    const sliderRef = useRef(null);
    const skinTonesFilters = [
        {
            value: 'Yellow',
        },
        {
            value: 'Light',
        },
        {
            value: 'Nougat',
        },
        {
            value: 'Medium',
        },
        {
            value: 'Dark',
        },
    ];

    const handleSkinTonePress = (e) => {
        const { filtervalue: filterValue /* filterkey: filterKey */ } = e.target.dataset;

        dispatch(setSkinTone(currentBuildIndex, filterValue));

        if (projectTitle && !showEditProjectInput && setEnableBuilder) {
            setEnableBuilder(true);
        }

        if (setShowSkinToneSelector) {
            setShowSkinToneSelector(false);
        }

        if (activeSection === 'heads') {
            dispatch(
                selectSectionAndCategory(
                    {
                        id: 'heads',
                        title: 'Heads',
                        emptyText: 'Choose a head',
                        handle: activeFilters ? activeFilters.filterHandle : `all-heads-new-1`,
                    },
                    null,
                    filterValue
                )
            );
        }
    };

    return (
        <div
            className={classNames('navigation__colourFilter', {
                error: skinToneError,
            })}
            ref={sliderRef}
            style={{ maxWidth: skinTonesFilters.length * 150 }}
        >
            <h3>{titleText}</h3>
            <ul className="swiper-wrapper">
                {skinTonesFilters.map((skinTone) => (
                    <li className="swiper-slide" key={skinTone.value}>
                        <button
                            data-filtervalue={skinTone.value}
                            data-filterkey="colour"
                            onClick={handleSkinTonePress}
                            className={`${skinTone.value.toLowerCase()} ${
                                skintone?.toLowerCase() === skinTone.value.toLowerCase() ? 'active' : ''
                            }`}
                        >
                            {skinTone.value}
                        </button>
                    </li>
                ))}
            </ul>
            <span className="error-message">Please select a skin tone to continue.</span>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        currentBuildIndex: state.currentBuildIndex,
        activeSection: state.navigation.selected,
        activeFilters: state.activeFilter,
        skintone: state.builds[state.currentBuildIndex].skintone,
    };
};

export default connect(mapStateToProps)(SkinToneFilters);
